import React, { Component,PureComponent } from 'react';
import PropTypes from 'prop-types';
import Header2 from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Control, LocalForm } from 'react-redux-form';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import ModalExample from "./pop";
import { Container, Row, Col } from 'reactstrap';

import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter';
import { dark } from 'react-syntax-highlighter/dist/esm/styles/prism';
import {config} from "../../../utility/swaggerClient";

import {Treebeard,decorators} from 'react-treebeard';
import './style.css'
// import styles from './styles';
// import NodeViewer from './NodeViewer';

import Header from './Header';
import {Link} from "react-router-dom";


const tree = {
  name: 'root',
  toggled: true,
  children: [
    {
      name: 'parent',
      children: [
        { name: 'child1',content: "abc" },
        { name: 'child2',content: "abc" }
      ]
    },
    {
      name: 'loading parent',
      loading: true,
      children: []
    },
    {
      name: 'parent',
      children: [
        {
          name: 'nested parent',
          children: [
            { name: 'nested child 1' },
            { name: 'nested child 2' }
          ]
        }
      ]
    }
  ]
};


const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'user.srcview',
    description: 'Page Header Title',
    defaultMessage: 'User Management'
  },
  headerSubTitle: {
    id: 'empty.label.name',
    description: 'Page Header Subtitle',
    defaultMessage: ''
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

const dev = "development-test";

class SrcView extends Component {
  componentDidMount(){
    this.setState({
      companyname: this.props.location.state[0].companyname,
      customer  : this.props.location.state[0].customer,
      dataFactory  : this.props.location.state[0].dataFactory,
      dataFactoryId  : this.props.location.state[0].dataFactoryId,
      prj  : this.props.location.state[0].project,
      env: dev,
      // app  : this.props.location.state[0].applicationName,
    })


    this.props.getusersList(this.props.username);
    var JSZip = require("jszip");
    var new_zip = new JSZip();
    const requestOptions = {
      method: 'GET',
      headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
    };
    let that = this;
    let prj =  this.props.location.state[0].project;
    let datafacotry = this.props.location.state[0].dataFactory;
    let customerid = this.props.location.state[0].customer;
    let env = this.state.env;
    fetch(`${config.protocol}://${config.host}/api/user/generatedCode/`+ customerid + '/' + datafacotry + '/' + prj, requestOptions)
      .then(response =>
      {
        console.log(response)
        return response.blob()
      })
      .then(data => {
        console.log(data)
        // this.setState({downloadzip : data});
        new_zip.loadAsync(data)
          .then(function(zip) {
            // zip.folder("nested").file("hello.txt", "Hello World\n");
            let rmlist = [];
            Object.keys(zip.files).forEach((filename)=> {
              if(filename.includes(".gitignore") || filename.includes("lock") || filename.includes("__pycache")){
                rmlist.push(filename);
              }
            })
            rmlist.forEach((file)=>{
              zip.remove(file);
            })

            console.log(zip);
            let filetree = {"name": "root", "children":[], "map":{}, "onSelect":that.onSelect, "toggled":true};
            Object.keys(zip.files).forEach((filename)=>{
              // console.log(filename)

              let levels = filename.split("/");
              let root = filetree;
              levels.forEach((folder,index)=>{
                if(folder === ""){
                  return;
                }
                if(!root["map"].hasOwnProperty(folder)){
                  if(!root.hasOwnProperty("children")){
                    root["children"]=[];
                  }
                  if(index === levels.length-1){
                    root["children"].push({"name": folder,"map":{},"content":filename,"onSelect":that.onSelect,"toggled":true});
                  }else{
                    root["children"].push({"name": folder,"map":{},"onSelect":that.onSelect,"toggled":true});
                  }

                  root["map"][folder] = root["children"].length-1;
                }else{
                  let idx = root["map"][folder];
                  root = root["children"][idx];
                }

              })
              // console.log(levels);
            })

            console.log(filetree)
            that.setState({data:filetree["children"][0],zip :zip,afterload: true});

            // return  zip.file("Sample_RedShift_Translation").async("string"); // a promise of "Hello World\n"
          });

      }).catch(err => console.log(err));
    // console.log(dsl)

    fetch(`${config.protocol}://${config.host}/api/user/generatedCodeenv/`+ customerid + '/' + datafacotry + '/' + prj, requestOptions)
      .then(response =>
      {
        return response.json();
      })
      .then(res => {
        let envs = [];
        res.data.forEach((item,i)=>{
          let arr = item.split("release_");
          if(arr.length > 1){
            envs.push(arr[1]);
          }
        })
        this.setState({envs : envs});
      })
  }

  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.onToggle = this.onToggle.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.state = {
      showInvite: false,
      showInviteSent: false,
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      role: "",
      delUser: "",
      delEmail: "",
      status: "",
      graph:`graph {}`,
      view: "",
      tables: {},
      steps: {},
      cols: [],
      code: "",
      data: tree,
      zip: "",
      prenode: {},
      factory: this.props.location.state[0].dataFactory,
      companyname: this.props.location.state[0].companyname,
      customer  : this.props.location.state[0].customer,
      dataFactoryId  : this.props.location.state[0].dataFactoryId,
      prj  : this.props.location.state[0].project,
      // app  : this.props.location.state[0].project,
      env: dev,
      envs: [],
      afterload: false
    };
  }

  onToggle = (node, toggled) =>{
    this.setState({cursor: node});
    console.log("toggle");
    console.log(node);

    if (node.children) {
      node.toggled = toggled;
    }
  }

  onSelect= (node)=> {
    console.log("select");
    const that = this;
    this.state.prenode.selected = false;
    node.selected = true;
    this.setState({prenode : node, code: "loading..."});
    this.state.zip.file(node.content).async("string").then(function (text) {
      that.setState({code:  text});
    });
  }

  selectItem = (value)=>{
    console.log(value);
    this.setState({delUser: value.username,status: value.status,delEmail: value.email})
  }
  openModal = ()=>{};

  confirmationText = "Your Admin user has been changed successfully. Please log In with the credential for new admin user."

  donwloadpipeline = ()=>{
    const FileDownload = require("js-file-download");
    if(this.state.env === dev){
      this.state.zip.generateAsync({type:"blob"})
        .then(function(content) {
          FileDownload(content, "code.zip");
        });
    }else{
      const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json',"Authorization": sessionStorage.getItem('jwt') },
      };
      let prj =  this.props.location.state[0].project;
      let datafacotry = this.props.location.state[0].dataFactory;
      let customerid = this.props.location.state[0].customer;
      let env = this.state.env;
      fetch(`${config.protocol}://${config.host}/api/user/generatedReleaseCode/`+ customerid + '/' + datafacotry + '/' + prj + '/' + env, requestOptions)
        .then(response =>
        {
          return response.blob()
        })
        .then(data => {
          FileDownload(data, "release_code.zip");
        }).catch(err => console.log(err));
    }

  }

  render() {
    const {cursor} = this.state;
    return (
      <div className="preview page">
        <Helmet>
          <title>
            {this.props.intl.formatMessage(messages.htmlHeader)} - SHIFT
          </title>
        </Helmet>
        <Header2
          title={this.props.intl.formatMessage(messages.headerTitle)}
          subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
          status = {this.props.status}
        />
        <ModalExample
          hasTitle
          warning
          className="modal_sm"
          reset={()=>this.props.logout()}
          setClick={click => this.openModal = click}
          content={this.confirmationText}/>

        <div className="main">
          {this.state.afterload && (
            <div
              className="panel"
              style={{
                width: '90%',
                padding: '40px',
                boxSizing: 'content-box',
                marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              <LocalForm
                className="form"
                model="user"
                // onSubmit={this.sendInvite}
              >
                <Row>
                  <Col xs="3" >
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Data Factory Name
                      </label>
                      <Control.text
                        model="user.factory"
                        value={this.state.factory}
                        disabled
                      />
                    </fieldset>
                  </Col>
                  <Col xs="3" >
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Project Name
                      </label>
                      <Control.text
                        model="user.prj"
                        value={this.state.prj}
                        disabled
                      />
                    </fieldset>
                  </Col>
                  <Col xs="3" >
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Application Name
                      </label>
                      <Control.text
                        model="user.app"
                        value={this.props.location.state[0].applicationName}
                        disabled
                      />
                    </fieldset>
                  </Col>
                  <Col xs="3" >
                    <fieldset>
                      <label style={{ textTransform: 'capitalize' }}>
                        Target Environment
                      </label>
                      <Control.select
                        model=".env"
                        autoFocus
                        value={this.state.env}
                        onChange={(e) => (this.setState({env : e.target.value}))}
                        required
                      >
                        {this.state.envs.map((item,i) => <option key={item} value={item}>{item}</option>)}
                      </Control.select>
                    </fieldset>
                  </Col>
                </Row>


                <div className="button-container" style={{ textAlign: 'center' }}>

                </div>
              </LocalForm>
              <Container style={{maxWidth:'2000px'}}>
                <Row >
                  <Col xs="4" className="filetree">
                    <Treebeard
                      data={this.state.data}
                      onToggle={this.onToggle}
                      onSelect={this.onSelect}
                      decorators={{...decorators, Header}}
                      customStyles={{
                        header: {
                          title: {
                            color: 'red'
                          }
                        }
                      }}
                    />
                    {/*<div style={styles.component}>*/}
                    {/*  <NodeViewer node={cursor} code={this.state.code}/>*/}
                    {/*</div>*/}
                    {/*<NodeViewer node={cursor}/>*/}
                  </Col>
                  {/*<Col xs="8" style={{height: '308px', overflow: 'auto',left:'-30px',top:'-8px'}} className="codeview">*/}
                  <Col xs="8" className="codeview">
                    <SyntaxHighlighter language="javascript" style={dark} showLineNumbers>
                      {this.state.code}
                    </SyntaxHighlighter>
                  </Col>
                </Row>
              </Container>




              <div className="button-container" style={{ textAlign: 'center' }}>

                <Link to={{
                  pathname: '/en-CA/projectmanagement/' + this.props.location.state[0].dataFactory + '/' + this.props.location.state[0].dataFactoryId,
                  state:[{
                    dataFactory : this.state.dataFactory,
                    dataFactoryId : this.state.dataFactoryId,
                    companyname : this.state.companyname,
                    customer : this.state.customer,
                    project: this.state.prj
                  }]
                }}>
                  <button
                    className="button"
                  >
                    <FormattedMessage
                      id="run-assessment.back.button.name"
                      textTransform="capitalize"
                      defaultMessage="Back"
                    />
                  </button>
                </Link>


                <button
                  className="button"
                  type="submit"
                  style={{ marginLeft: '20px' }}
                  onClick={()=>{this.donwloadpipeline()} }
                >
                  DOWNLOAD
                </button>
              </div>
            </div>
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

SrcView.propTypes = {
  username: PropTypes.string,
  usersList: PropTypes.array
};

export default injectIntl(SrcView);



// WEBPACK FOOTER //
// ./src/components/views/SrcView/index.js